import {Country, OfferType} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_HOUSE_CONTENT} from "../../constants/offer_generated_description_house_content";
import {IOffer} from "../../types/property/IOffer";
import {OfferGeneratedDescriptionParkingPlaces} from "./OfferGeneratedDescriptionParkingPlaces";
import {OfferGeneratedDescriptionRoomRanges} from "./OfferGeneratedDescriptionRoomRanges";
import {OfferGeneratedDescriptionTextHouses} from "./OfferGeneratedDescriptionTextHouses";

interface IProps {
    country: Country;
    offer: IOffer;
    type: OfferType;
}

export const OfferGeneratedDescriptionHouse = (props: IProps) => {
    const {country, offer, type} = props;
    const {AVAILABLE_HOUSES_HEADER} = OFFER_GENERATED_DESCRIPTION_HOUSE_CONTENT;

    return (
        <>
            <OfferGeneratedDescriptionTextHouses country={country} offer={offer} />

            <OfferGeneratedDescriptionRoomRanges
                country={country}
                header={AVAILABLE_HOUSES_HEADER}
                rooms_ranges={offer.stats?.rooms_ranges ?? []}
                type={type}
            />

            <OfferGeneratedDescriptionParkingPlaces
                country={country}
                investor={offer.investor}
                offerName={offer.name}
                parking_places={offer.parking_places}
                vendor={offer.vendor}
            />
        </>
    );
};
import {Country, OfferType} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_HOUSE_CONTENT} from "../../constants/offer_generated_description_house_content";
import {IOffer} from "../../types/property/IOffer";
import {OfferGeneratedDescriptionParkingPlaces} from "./OfferGeneratedDescriptionParkingPlaces";
import {OfferGeneratedDescriptionRoomRanges} from "./OfferGeneratedDescriptionRoomRanges";
import {OfferGeneratedDescriptionTextHouses} from "./OfferGeneratedDescriptionTextHouses";

interface IProps {
    country: Country;
    offer: IOffer;
    type: OfferType;
}

export const OfferGeneratedDescriptionHouse = (props: IProps) => {
    const {country, offer, type} = props;
    const {AVAILABLE_HOUSES_HEADER} = OFFER_GENERATED_DESCRIPTION_HOUSE_CONTENT;

    return (
        <>
            <OfferGeneratedDescriptionTextHouses country={country} offer={offer} />

            <OfferGeneratedDescriptionRoomRanges
                country={country}
                header={AVAILABLE_HOUSES_HEADER}
                rooms_ranges={offer.stats?.rooms_ranges ?? []}
                type={type}
            />

            <OfferGeneratedDescriptionParkingPlaces
                country={country}
                investor={offer.investor}
                offerName={offer.name}
                parking_places={offer.parking_places}
                vendor={offer.vendor}
            />
        </>
    );
};
